// extracted by mini-css-extract-plugin
export default {"root":"style_root__K5oRR","loaderOverlay":"style_loaderOverlay__gksV0"};